import { IconButton } from '@mui/material';
import { palette } from '@silbo/ui';
import { ReactElement } from 'react';
type FareButtonProps = {
  success: boolean;
  disabled: boolean;
  isOfflineMode: boolean;
  onClick: () => void;
  Icon: ReactElement;
};

export const FareButton = ({ Icon, disabled, success, isOfflineMode, onClick }: FareButtonProps) => {
  return (
    <IconButton
      variant={success ? 'outlined' : 'filled'}
      color={isOfflineMode ? 'error' : success ? 'success' : 'primary'}
      size="large"
      disabled={disabled}
      sx={{
        borderWidth: success || isOfflineMode ? 1 : 0,
        '&.Mui-disabled': {
          color: isOfflineMode ? palette.error.main : success ? palette.success.main : undefined,
        },
      }}
      onClick={() => onClick()}
    >
      {Icon}
    </IconButton>
  );
};
